module.exports = __webpack_public_path__ + "static/media/UASJ_de_la_SEGOB_.94344e33.png";